import { I18n } from "../hooks/useTranslations";

export type CustomError = {
  error: {
    status: number;
    message: string;
    code: number | null;
  };
};

// export type GenericError = CustomError & {
//   status: number;
// };

// export type NotUnauthorizedError = CustomError & {
//   status: 401;
// };

// export type NotFoundError = CustomError & {
//   status: 404;
// };

// export type BadRequestError = CustomError & {
//   status: 400;
// };

// export type ConflictError = CustomError & {
//   status: 409;
// };

// export const isGenericError = (error: any): boolean =>
//   error.status && error.status >= 500 && error.status < 600;

// export const isUnauthorized = (error: any): boolean => error?.json?.error?.status === 401; // TODO needed? remove?

export const isForbidden = (error: any): boolean => error?.json?.error?.status === 403 || error?.status === 403;

export const isNotFound = (error: any): boolean => error?.json?.error?.status === 404 || error?.status === 404;

// export const isBadRequest = (error: any): boolean => error?.json?.error?.status === 400;

export const isConflict = (error: any): boolean => error?.json?.error?.status === 409 || error?.status === 409;

export const isClientError = (error: any): boolean => {
  const status = error?.json?.error?.status ?? error?.status;
  return typeof status === "number" && status >= 400 && status < 500;
};

export const is6500027 = (error: any) => error?.json?.error?.code === 6500027;

export const getErrorCode = (error: any): number | null => {
  // Try err.json.error.code (standard format)
  if (error?.json?.error?.code) {
    return error.json.error.code;
  }

  // Try err.error.code (alternative format)
  if (error?.error?.code) {
    return error.error.code;
  }

  // Try parsing JSON from error message (WretchError format)
  if (error?.message && typeof error.message === "string") {
    try {
      const parsed = JSON.parse(error.message);
      if (parsed?.error?.code) {
        return parsed.error.code;
      }
    } catch (e) {
      // Not JSON or invalid format, ignore
    }
  }

  return null;
};

export const getErrorMessage = (i18n: I18n, error: any): string => {
  const code = getErrorCode(error);
  if (code) {
    const msg = i18n.errorsMap.get(code);
    return msg ?? `${i18n.translation.common.genericError} (${code})`;
  }
  return i18n.translation.common.genericError;
};
